import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ImageUploaderComponent } from '@shared/modules/uploader/containers/image-uploader/image-uploader.component';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { UploaderComponent } from '@shared/modules/uploader/containers/uploader/uploader.component';

@Component({
  selector: 'app-image-input',
  templateUrl: './image-input.component.html',
  imports: [ImageUploaderComponent, ManageValidatorDisplayDirective, UploaderComponent],
})
export class ImageInputComponent extends FieldType {}
